var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import nemWrapper from '../../../ts/nemWrapper';
import walletModel from '../../../ts/walletModel';
// コンポーネントの設定
var MyWalletPrivate = /** @class */ (function (_super) {
    __extends(MyWalletPrivate, _super);
    function MyWalletPrivate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wallet = new walletModel();
        return _this;
    }
    MyWalletPrivate = __decorate([
        Component({
            name: 'my_wallet_private',
            methods: {},
            data: function () { return ({
                nem: new nemWrapper(),
                title: "プライベートキー(秘密鍵)",
                description: "メモに書き留め厳重に保管して下さい。"
            }); }
        })
    ], MyWalletPrivate);
    return MyWalletPrivate;
}(Vue));
export default MyWalletPrivate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/details/MyWalletPrivate.vue
// module id = 263
// module chunks = 1